import { __, eq, includes } from 'lodash/fp';
import { ThunkMiddleware } from 'redux-thunk';

import { localizeText } from '@mews-commander/utils';
import {
    NOTIFICATION_FETCHED,
    NOTIFICATION_MARKED_PENDING,
    NOTIFICATION_MARKED_SEEN,
    NOTIFICATIONS_FETCHED,
} from '../modules/notifications/actions/common';
import { getUnseenMessageNotificationsCount } from '../modules/notifications/selectors';

const NOTIFICATION_ACTION_TYPES = [
    NOTIFICATION_FETCHED,
    NOTIFICATIONS_FETCHED,
    NOTIFICATION_MARKED_SEEN,
    NOTIFICATION_MARKED_PENDING,
];
const DOCUMENT_TITLE_CHANGED = 'DOCUMENT_TITLE_CHANGED';

const isNotificationAction = includes(__, NOTIFICATION_ACTION_TYPES);
const isDocumentTitleChangeAction = eq(DOCUMENT_TITLE_CHANGED);

export const changeDocumentTitle = (title: string) => ({ type: DOCUMENT_TITLE_CHANGED, payload: title });

export const changeDocumentTitleLocalized = (...args: Parameters<typeof localizeText>) =>
    changeDocumentTitle(localizeText(...args));

export default (contextDocument: Document): ThunkMiddleware =>
    (store) =>
    (next) =>
    (action) => {
        const { type, payload } = action;
        const actionResult = next(action);

        if (isNotificationAction(type)) {
            const unseenCount = getUnseenMessageNotificationsCount(store.getState());

            const tabTitle = getTitleWithoutMessageCount(contextDocument.title);
            contextDocument.title = prependMessageCount(tabTitle, unseenCount);
        }

        if (isDocumentTitleChangeAction(type)) {
            const unseenCount = getUnseenMessageNotificationsCount(store.getState());

            const tabTitle = getTitleWithoutMessageCount(payload);
            contextDocument.title = prependMessageCount(tabTitle, unseenCount);
        }

        return actionResult;
    };

const messageCountRegex = new RegExp(/^\(\d*\+?\) /g);
const getTitleWithoutMessageCount = (title: string) => title.replace(messageCountRegex, '');

const prependMessageCount = (title: string, count: number) => (count > 0 ? `(${count}) ${title}` : title);
